interface ControlBarProps {
  isMuted: boolean;
  isCameraOff: boolean;
  isChatOpen: boolean;
  onToggleMute: () => void;
  onToggleCamera: () => void;
  onToggleChat: () => void;
  onLeave: () => void;
  unreadCount?: number;
}

export function ControlBar({
  isMuted,
  isCameraOff,
  isChatOpen,
  onToggleMute,
  onToggleCamera,
  onToggleChat,
  onLeave,
  unreadCount = 0,
}: ControlBarProps) {
  return (
    <div className="flex items-center justify-center gap-3 bg-neutral-900/95 backdrop-blur-sm border-t border-neutral-800 px-4 py-3">
      {/* Mute */}
      <button
        onClick={onToggleMute}
        title={isMuted ? 'Unmute' : 'Mute'}
        className={`
          flex h-12 w-12 items-center justify-center rounded-full text-lg
          transition-colors
          ${isMuted
            ? 'bg-red-600 hover:bg-red-700 text-white'
            : 'bg-neutral-700 hover:bg-neutral-600 text-white'}
        `}
      >
        {isMuted ? '🔇' : '🎙️'}
      </button>

      {/* Camera */}
      <button
        onClick={onToggleCamera}
        title={isCameraOff ? 'Turn on camera' : 'Turn off camera'}
        className={`
          flex h-12 w-12 items-center justify-center rounded-full text-lg
          transition-colors
          ${isCameraOff
            ? 'bg-red-600 hover:bg-red-700 text-white'
            : 'bg-neutral-700 hover:bg-neutral-600 text-white'}
        `}
      >
        {isCameraOff ? '📷' : '📸'}
      </button>

      {/* Chat */}
      <button
        onClick={onToggleChat}
        title="Chat"
        className={`
          relative flex h-12 w-12 items-center justify-center rounded-full text-lg
          transition-colors
          ${isChatOpen
            ? 'bg-ember-600 hover:bg-ember-700 text-white'
            : 'bg-neutral-700 hover:bg-neutral-600 text-white'}
        `}
      >
        💬
        {unreadCount > 0 && !isChatOpen && (
          <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-ember-500 text-xs font-bold text-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {/* Divider */}
      <div className="h-8 w-px bg-neutral-700" />

      {/* Leave */}
      <button
        onClick={onLeave}
        title="Leave call"
        className="flex h-12 w-16 items-center justify-center rounded-full bg-red-600 hover:bg-red-700 text-white text-lg transition-colors"
      >
        📵
      </button>
    </div>
  );
}
